import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform, inject } from '@angular/core';
import { UtilService } from '../services/util.service';
@Pipe({
  name: 'staticoptions',
  standalone: false  //NOSONAR
})
export class StaticoptionsPipe implements PipeTransform {
  private datePipe = inject(DatePipe);
  private util = inject(UtilService);

  transform(value: any, ...args: any[]): any {
    let options: any[] = [];
    switch (value) {
      case 'dateformat': {
        const values = this.util.dateFormats;
        options = values.map((val) => {
          return {
            label: `${val} (${this.datePipe.transform(new Date(), val)})`,
            value: val
          };
        });
        break;
      }
      case 'datetimeformat': {
        const dtvalues = this.util.dateTimeFormats;

        if (args[0]) {
          options = dtvalues
            .filter((opt) => opt.toLowerCase().startsWith(args[0].toLowerCase()))
            .map((val) => {
              return {
                label: `${val} (${this.datePipe.transform(new Date(), val)})`,
                value: val
              };
            });
        } else {
          options = dtvalues.map((val) => {
            return {
              label: `${val} (${this.datePipe.transform(new Date(), val)})`,
              value: val
            };
          });
        }
        break;
      }
      case 'timeformat': {
        const tvalues = ['h:mm:ss a', 'h:mm a', 'H:mm', 'H:mm:ss'];
        options = tvalues.map((val) => {
          return {
            label: `${val} (${this.datePipe.transform(new Date(), val)})`,
            value: val
          };
        });
        break;
      }
      case 'numberformat':
        options = [
          {
            label: '9.999,00',
            value: {
              displayLabel: '9.999,00',
              thousandSeparator: '.',
              decimalSeperator: ','
            }
          },
          {
            label: '9,999.00',
            value: {
              displayLabel: '9,999.00',
              thousandSeparator: ',',
              decimalSeperator: '.'
            }
          },
          {
            label: '9 999.00',
            value: {
              displayLabel: '9.999,00',
              thousandSeparator: ' ',
              decimalSeperator: '.'
            }
          },
          {
            label: '9 999,00',
            value: {
              displayLabel: '9 999,00',
              thousandSeparator: ' ',
              decimalSeperator: ','
            }
          },
          {
            label: '9 999,00',
            value: {
              displayLabel: '9 999,00',
              thousandSeparator: '',
              decimalSeperator: ','
            }
          },
          {
            label: '9 999,00',
            value: {
              displayLabel: '9 999,00',
              thousandSeparator: '',
              decimalSeperator: '.'
            }
          }
        ];
        break;
      default: {
        break;
      }
    }
    return options;
  }
}
